import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SubscriptionPlan.css";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import secureLocalStorage from "react-secure-storage";

const SubscriptionPlan = () => {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState("");
  const [subscribe, setSubscribe] = useState(null);

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    const userID = secureLocalStorage.getItem("Id");
    const isSubscribe = secureLocalStorage.getItem("Subscription");
    setUserId(userID);
    setRole(userRole);
    if (isSubscribe) {
      setSubscribe(isSubscribe);
    }
  }, []);

  const handleClick = async (IsPlanned) => {
    if (role === undefined || role === null) {
      toast("Please Login First!!", {
        duration: 3000,
        style: {
          fontSize: "20px",
          borderRadius: "10px",
          background: "var(--color-white-50)",
          color: "#fff",
        },
      });
      return;
    }
    if (role === "admin") {
      navigate("/");
      return;
    }
    if (IsPlanned) {
      navigate("/stripe/product1");
    } else {
      navigate("/stripe/product0");
    }
  };

  useEffect(() => {
    const GetPlans = async () => {
      try {
        const response = await axios.get(
          "http://127.0.0.1:8000/admins/get-all-plan"
        );

        if (response.status === 200) {
          const modifiedPlans = response.data.plans.map((plan, index) => {
            let additionalDescription = "";
            if (index === 0) {
              additionalDescription = ", No real Transactions";
            } else {
              additionalDescription = ", Real Transactions";
            }
            const descriptionArray = (
              plan.Plan_Feature + additionalDescription
            ).split(", ");

            return {
              id: plan.Plan_id,
              title: plan.Plan_Title,
              subTitle: plan.Plan_subHeader,
              price: plan.Plan_Price,
              accountType: plan.AccountType,
              description: descriptionArray,
              isSubscribed: index === 0 ? false : true,
            };
          });

          console.log("modified are ", modifiedPlans);
          setPlans(modifiedPlans);
        } else {
          console.error("Error:", response.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    GetPlans();
    return () => {
      // Cleanup code, if needed
    };
  }, []);

  return (
    <>
      {role == "admin" || subscribe == true ? null : (
        <section id="packages" className="subscription-plan">
          <div className="plan-frame">
            <h1 className="plan-title">Choose Your Plan</h1>
            <div className="background-frame">
              <img
                className="subscription-plan-background"
                alt=""
                src="/subscription-plan-background.png"
              />
              <div className="subscription-rectangle" />
              <div className="frame2">
                {plans.map((tier) => (
                  <div key={tier.id} className="plan-type">
                    <div
                      className={`plan-container ${
                        tier.isSubscribed ? "bg-red" : "bg-white"
                      }`}
                    >
                      <h3
                        className={`frame-wrapper ${
                          tier.isSubscribed ? "color-red" : "color-white"
                        }`}
                      >
                        <div
                          className={`package-wrapper ${
                            tier.isSubscribed ? "bg-white" : "bg-red"
                          }`}
                        >
                          {tier.title}
                        </div>
                      </h3>
                      <div className="price">
                        <p className="p">
                          <span className="span">$</span>
                          <b>{tier.price}</b>
                        </p>
                      </div>
                      <legend className="frame-inner" />
                      <div className="bot-will-execute">
                        {tier.description.map((item, index) => (
                          <p key={index} className="p">
                            {item}
                          </p>
                        ))}
                      </div>
                    </div>
                    <button
                      className={
                        tier.isSubscribed ? "choose-plan2" : "choose-plan1"
                      }
                    >
                      <div
                        className={`choose-plan ${
                          tier.isSubscribed ? "color-red" : "color-white"
                        }`}
                        onClick={() => handleClick(tier.isSubscribed)}
                      >
                        Choose Plan
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="contact-wrapper">
            <div className="divicon-parent">
              <div className="divicon7">
                <div className="security-icon-frame1">
                  <div className="circle" />
                </div>
              </div>
              <div className="contact-info">
                <span>
                  Having trouble while choosing a plan? Email us, and we will
                  try our best to resolve your matter.
                </span>
              </div>
            </div>
          </div>
          <Toaster />
        </section>
      )}
    </>
  );
};

export default SubscriptionPlan;
